import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  fetching: false,
  data: {},
  subscribed: null
}

const actions = generateActions('home/GET')
const actionsSubsribe = generateActions('home/SUBSCRIBE_ARTICLES')

export const getHomeData = createAction(API_CONST, () => ({
  actions,
  url: 'stats'
}))

export const subscribe = createAction(API_CONST, email => ({
  method: 'POST',
  params: { email },
  actions: actionsSubsribe,
  url: 'articles/subscribe'
}))

export default handleActions({
  [actions[0]]: state => ({
    ...state,
    data: {},
    fetching: true
  }),
  [actions[1]]: (state, { payload }) => ({
    ...state,
    data: payload,
    fetching: false
  }),
  [actions[2]]: state => ({ ...initial }),
  [actionsSubsribe[1]]: state => ({ ...state, subscribed: true }),
  [actionsSubsribe[2]]: state => ({ ...state, subscribed: false })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/home/index.js